// @flow
import React, { type Node } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import classNames from 'classnames/bind';

import Modal from 'app/common/components/Modal';
import shadows from 'app/common/containers/shadows';
import styles from './TariffModal.scss';


const cx = classNames.bind(styles);

type Props = {
  title: string,
  description: string,
  close: (e: SyntheticEvent<HTMLElement>) => void,
  children: Node,
  updateScroll: (Object) => void,
  isTopShadow: boolean,
  isBottomShadow: boolean,
  isOpen?: boolean,
  toggleModal?: (e: SyntheticEvent<HTMLElement>) => void,
};

const TariffModal = ({
  title,
  description,
  close,
  children,
  updateScroll,
  isTopShadow,
  isBottomShadow,
  isOpen,
  toggleModal,
}: Props) => (
  <Modal
    close={close}
    modalClassName={styles.tariffModal}
    className={styles.modal}
    isOpen={isOpen}
    toggleModal={toggleModal}
  >
    <div className={styles.modalHeader}>{title}</div>
    <div className={styles.modalInfo}>{description}</div>
    <div className={cx(styles.content, { isBottomShadow })}>
      <Scrollbars
        className={cx(styles.content, { isTopShadow })}
        onUpdate={updateScroll}
      >
        {children}
      </Scrollbars>
    </div>
  </Modal>
);

export default shadows(TariffModal);
